import React from 'react';
import PropTypes from 'prop-types';

export const AccountsToApprove = ({ width, height, ...props }) => (
  <svg
    data-icon='accounts-to-approve'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      d='M2 16V14H4V16H2ZM2 12V10H4V12H2ZM2 8V6H4V8H2ZM6 16V14H10V16H6ZM6 12V10H19V12H6ZM6 8V6H19V8H6ZM15.95 20L11.7 15.75L13.125 14.325L15.95 17.15L21.6 11.5L23 12.95L15.95 20Z'
      fill='currentColor'
    />

  </svg>
);

AccountsToApprove.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

AccountsToApprove.defaultProps = {
  width: 24,
  height: 24,
};
